import React, {useEffect, useState} from 'react';
import SingleSelector from "../../components/singleSelector";
import {CSSTransition} from "react-transition-group";
import ReportsPlaceholder from "../../components/placeholders/reportsPlaceholder";
import axios from 'axios';
import {useStoreState} from "easy-peasy";
import NoResults from "../../components/noResults";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseApiUrl} from "../../_constants";

export default function Reports(){
    const activeOrganization = useStoreState(state=>state.user.activeOrganization);
    const [notSignedUp,setNotSignedUp] = useState([]);
    const [waiting,setWaiting] = useState([]);
    const [gettingPaid,setGettingPaid] = useState([]);
    const [totalEmployees, setTotalEmployees] = useState(0);
    const [mostRowsInColumn,setMostRowsInColumn] = useState(7);
    const [selectedMonth,setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear,setSelectedYear] = useState(new Date().getFullYear());
    const [matchStart,setMatchStart] = useState(null);
    const [matchEnd,setMatchEnd] = useState(null);
    const rowHeight = 44;
    const months = [
        {label:'January',value:0, selected:new Date().getMonth() === 0},
        {label:'February',value:1, selected:new Date().getMonth() === 1},
        {label:'March',value:2, selected:new Date().getMonth() === 2},
        {label:'April',value:3, selected:new Date().getMonth() === 3},
        {label:'May',value:4, selected:new Date().getMonth() === 4},
        {label:'June',value:5, selected:new Date().getMonth() === 5},
        {label:'July',value:6, selected:new Date().getMonth() === 6},
        {label:'August',value:7, selected:new Date().getMonth() === 7},
        {label:'September',value:8, selected:new Date().getMonth() === 8},
        {label:'October',value:9, selected:new Date().getMonth() === 9},
        {label:'November',value:10, selected:new Date().getMonth() === 10},
        {label:'December',value:11, selected:new Date().getMonth() === 11}
        ];

    const getYears = () =>{
        let years = [];
        const curYear = new Date().getFullYear();
        for(let i=0;i<10;i++){
            years.push({label:curYear - i,value:curYear - i, selected:new Date().getFullYear()===curYear - i});
        }
        return years;
    };

    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        axios.get('/organizations/'+activeOrganization.organization_id+'/reports').then(response=>{

            setNotSignedUp(response.data.not_signed_up);
            setWaiting(response.data.waiting);
            setGettingPaid(response.data.with_payments);
            setTotalEmployees(response.data.not_signed_up.length + response.data.waiting.length + response.data.with_payments.length);
            setMostRowsInColumn(Math.min(25,Math.max(response.data.not_signed_up.length, response.data.waiting.length, response.data.with_payments.length)))
            setLoading(false);
        }).catch(e=>{});
    },[]);

    useEffect(()=>{
        setLoading(true);
        let endDate = Math.floor(new Date(selectedYear,selectedMonth + 1 ).getTime() / 1000);
        let startDate = Math.floor(new Date(selectedYear,selectedMonth ).getTime() / 1000);
        axios.get('/organizations/'+activeOrganization.organization_id+'/reports?start_time='+startDate+'&end_time='+endDate).then(response=>{

            setNotSignedUp(response.data.not_signed_up);
            setWaiting(response.data.waiting);
            setGettingPaid(response.data.with_payments);
            setTotalEmployees(response.data.not_signed_up.length + response.data.waiting.length + response.data.with_payments.length);
            setMostRowsInColumn(Math.min(25,Math.max(response.data.not_signed_up.length, response.data.waiting.length, response.data.with_payments.length)))
            setLoading(false);
        }).catch(e=>{});

    },[selectedMonth,selectedYear]);

    const getPercent = (count) =>{
        return Math.floor((count / totalEmployees) * 100) + '%';
    };


    function downloadMatchReport() {
        axios.get('/auth/generate-token').then(response => {
            let start = null;
            let end = null;
            if(matchStart){
                start = new Date(matchStart).getTime();
            }
            if(matchEnd){
                end = new Date(matchEnd).getTime();
            }
            let path = baseApiUrl + '/organizations/' + activeOrganization.organization_id + '/reports/match-report/';
            path += '?match_start=' + (start || '');
            path += '&match_end=' + (end || '');
            if (response.data.token) {
                path += '&auth-token=' + response.data.token;
                window.open(path,'_blank');
            }
        }).catch(e => { })
    }



    return (
        <div className={'full-width page'}>
            <div className={'header'}>
                <div>
                    <h1 className={'heading'} >
                        Reports
                    </h1>
                </div>

            </div>
            <div className={'list-section'} style={{marginBottom: '50px',zIndex:8}}>
                <div className={'body'}>
                    <div className={'form-container'}>
                        <h2 style={{marginBottom:24}}>Match Report</h2>
                        <div className={'match-report-form'}>
                            <label>
                                Start Date
                                <DatePicker  selected={matchStart} onChange={date=>setMatchStart(date)} onSelect={(date)=>{setMatchStart(date)}}/>
                            </label>
                            <label>
                                End Date
                                <DatePicker  selected={matchEnd} onChange={date=>setMatchEnd(date)} onSelect={(date)=>{setMatchEnd(date)}}/>
                            </label>
                            <button className={'simple-rounded-button small green'} onClick={downloadMatchReport}>Download Match Report</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'list-section'}>

                <div className={'body'}>
                    <div className={'button-holder'} style={{marginBottom: '20px'}}>
                        <SingleSelector options={months} changeHandler={setSelectedMonth} simple={true} />
                        <SingleSelector options={getYears()} changeHandler={setSelectedYear} simple={true}/>
                    </div>
                    <CSSTransition
                        in={loading}
                        timeout={{
                            appear: 500,
                            enter: 300,
                            exit: 0,
                        }}
                        classNames="fade"
                        unmountOnExit
                    >
                        <ReportsPlaceholder />
                    </CSSTransition>
                    <CSSTransition
                        in={!loading && totalEmployees>0}
                        timeout={{
                            enter: 300,
                            exit: 0,
                        }}
                        classNames="fade"
                        unmountOnExit
                    >

                        <div className={'report-holder'}>
                            <div className={'report-column'}>
                                <h5>{getPercent(notSignedUp.length)} ({notSignedUp.length}) have not signed up</h5>
                                <div style={{height: (mostRowsInColumn + 1) * rowHeight}}>
                                    {
                                        notSignedUp.map(user=>
                                            <span key={user.user_id}>{user.display_name}</span>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={'report-column'}>
                                <h5>{getPercent(waiting.length)} ({waiting.length}) Are waiting for their first payment</h5>
                                <div style={{height: (mostRowsInColumn + 1) * rowHeight}}>
                                    {
                                        waiting.map(user=>
                                            <span key={user.user_id}>{user.display_name}</span>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={'report-column'}>
                                <h5>{getPercent(gettingPaid.length)} ({gettingPaid.length}) are receiving payments!</h5>
                                <div style={{height: (mostRowsInColumn + 1) * rowHeight}}>
                                    {
                                        gettingPaid.map(user=>
                                            <span key={user.user_id}>{user.display_name}</span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                    </CSSTransition>
                    <CSSTransition
                        in={!loading && totalEmployees<=0}
                        timeout={{
                            enter: 300,
                            exit: 0,
                        }}
                        classNames="fade"
                        unmountOnExit
                    >
                        <NoResults />
                    </CSSTransition>
                </div>
            </div>
        </div>
    )
}
